<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.formation_area.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.order')"
      label-for="input-order"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-order"
        name="input-order"
        v-model="$v.formation_area.order.$model"
        :state="validateState('order')"
        aria-describedby="input-order-live-feedback"
        size="sm"
        type="number"
      ></b-form-input>
      <b-form-invalid-feedback id="input-order-live-feedback">{{
        $t("reusable.common.greaterThanZero")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
      :state="validateState('description')"
    >
      <div
        class="form-description mb-2"
        :class="{ 'is-invalid': validateState('description') == false }"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="formation_area.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="formation_area"
        :content_rich_text="formation_area.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(formation_area, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="formation_area"
          :Text="formation_area.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.formation_area.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(this.formation_area.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="formation_area"></ModificationDate>
    </b-form-group>
    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.formation_area.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteFormationArea"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
export default {
  name: "FormationAreaForm",
  mixins: [validationMixin],
  components: {
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    FormationArea: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          school: this.institution_id,
          active: true,
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    institution_id: {
      type: Number,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formation_area: this.FormationArea
        ? {
            id: this.FormationArea.id,
            name: this.FormationArea.name,
            order: this.FormationArea.order ? this.FormationArea.order : 1,
            description: this.FormationArea.description,
            creation_date: this.FormationArea.creation_date,
            created_by: this.FormationArea.created_by,
            updated_by: this.FormationArea.updated_by,
            update_date: this.FormationArea.update_date,
          }
        : { id: generateUniqueId(), name: "", order: 1, description: "" },
    };
  },
  validations: {
    formation_area: {
      name: {
        required,
        minLength: minLength(5),
      },
      order: {
        required,
        minValue: minValue(1),
      },
      description: {
        required,
      },
    },
  },
  created() {},
  methods: {
    patchDescription(object, text) {
      this.formation_area.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.formation_area[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.formation_area.$touch();
      if (this.$v.formation_area.$anyError) {
        return;
      }
      if (isNaN(this.formation_area.id)) {
        this.createFormationArea();
      } else this.updateFormationArea();
    },
    createFormationArea() {
      this.formation_area.school = this.institution_id;
      this.$store
        .dispatch(
          names.POST_FORMATION_AREA,
          this.formation_area,
          this.formation_area.school
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.formationarea",
                false,
                "Área De Formación"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateFormationArea() {
      this.formation_area.school = this.institution_id;
      this.$store
        .dispatch(
          names.UPDATE_FORMATION_AREA,
          this.formation_area,
          this.formation_area.school
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.formationarea",
                false,
                "Área De Formación"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    deleteFormationArea() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.formationarea",
            false,
            "Área De Formación"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_FORMATION_AREA,
            this.formation_area.id
          );
          this.$emit("deleted", this.formation_area);
        }
      });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description.is-invalid {
  border-color: #dc3545;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>